export default __webpack_public_path__ + "static/media/997.40418acf.gif";